var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{staticClass:"btn btn-sm btn-outline-info",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.preventDefault();return _vm.getResultLink()}}},[_vm._v("View result")])])}
var staticRenderFns = []

export { render, staticRenderFns }